import {applyMiddleware, compose, createStore} from 'redux'
import createHistory from 'history/createBrowserHistory';
import {routerMiddleware} from 'react-router-redux'
import {reducers} from './reducers/index'
import thunkMiddleware from 'redux-thunk';
import {LOGIN_FAILURE, no401redirectAttribute} from './actions/AccountActions';
import createRedirect401Middleware from './redirect401Middleware';

export const history = createHistory();
const redirect401Middleware = createRedirect401Middleware(LOGIN_FAILURE, no401redirectAttribute);
const middleware = [thunkMiddleware, redirect401Middleware, routerMiddleware(history)];
const composeEnhancers = process.env.NODE_ENV === 'development' ? (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose) : compose;

const store = createStore(
    reducers,
    composeEnhancers(
        applyMiddleware(...middleware)
    )
);


export default store;



// WEBPACK FOOTER //
// ./src/store.js